module.exports = __webpack_public_path__ + "static/media/backend_logo_with_name.f0ffd6cc.webp";